import Vue from "vue";
import Vuex from "vuex";
import pathify, { make } from "vuex-pathify";
import todo from "./todo";

const state = {};
const mutations = make.mutations(state);

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [pathify.plugin],
  state,
  mutations,
  actions: {},
  modules: {
    todo,
    dialog: {
      state: {
        switchSigninSignup: false,
        roomSetting: false,
        dataprofile: false,
        datarditroom: "",
        scheduleSetting: false,
        dialogDevices: false,
        editschedule: false,
        editroom: false,
        dialogLogin: false,
        uuid_video: "",
        uuid_audio: "",
        donwloadvideo: "",
        historyload: "",
        datahistory: "",
        reporthistory: false,
        datareporthistory: "",
        dialogcoppylink: false,
        datacoppylink: "",
        dataparticipants: "",
        dataparticipantsend: "",
        dataRoomSchedule: [],
      },
      mutations: {
        SET_DIALOG_SWITCH: (state, payload) => {
          state.switchSigninSignup = payload;
        },
        SET_DIALOG_ROOMSETTING: (state, payload) => {
          state.roomSetting = payload;
        },
        SET_DIALOG_SCHEDULESETTING: (state, payload) => {
          state.scheduleSetting = payload;
        },
        SET_DIALOG_EDITSCHEDULE: (state, payload) => {
          state.editschedule = payload;
        },
        SET_DIALOG_DEVICE: (state, payload) => {
          state.dialogDevices = payload;
        },
        SET_DIALOG_LOGIN: (state, payload) => {
          state.dialogLogin = payload;
        },
        SET_DIALOG_DATAEDIT: (state, payload) => {
          state.datarditroom = payload;
        },
        SET_DIALOG_EDITROOM: (state, payload) => {
          state.editroom = payload;
        },
        SET_DIALOG_UUID_VIDEO: (state, payload) => {
          state.uuid_video = payload;
        },
        SET_DIALOG_UUID_AUDIO: (state, payload) => {
          state.uuid_audio = payload;
        },
        SET_DATA_HISTORY: (state, payload) => {
          state.datahistory = payload;
        },
        SET_DIALOG_REPORTMEET: (state, payload) => {
          state.reportmeet = payload;
        },
        SET_DIALOG_REPORTVOTE: (state, payload) => {
          state.reportvote = payload;
        },
        SET_DIALOG_VIDEO: (state, payload) => {
          state.donwloadvideo = payload;
        },
        SET_DIALOG_HISTORYLOAD: (state, payload) => {
          state.historyload = payload;
        },
        SET_DIALOG_REPORTHISTORY: (state, payload) => {
          state.reporthistory = payload;
        },
        SET_DATA_REPORTHISTORY: (state, payload) => {
          state.datareporthistory = payload;
        },
        SET_DIALOG_COPPYLINK: (state, payload) => {
          state.dialogcoppylink = payload;
        },
        SET_DATA_COPPYLINK: (state, payload) => {
          state.datacoppylink = payload;
        },
        SET_DIALOG_PARTICIPANTS: (state, payload) => {
          state.dataparticipants = payload;
        },
        SET_DIALOG_PARTICIPANTSEND: (state, payload) => {
          state.dataparticipantsend = payload;
        },
        SET_DIALOG_PROFILE: (state, payload) => {
          state.dataprofile = payload;
        },
        SET_DATA_ROOM_SCHEDULE: (state, payload) => {
          state.dataRoomSchedule = payload;
        },
      },
      actions: {
        setdatadialogparticipants_pexip({ commit }, payload) {
          commit("SET_DIALOG_PARTICIPANTS", payload);
        },
        // setgetProfile({ commit }, payload) {
        //   commit('SET_DIALOG_PARTICIPANTS', payload)
        //   console.log('payload', payload)
        //   this.axios.get(process.env.VUE_APP_API + '/api/v1/theme/get/' +  payload).then(res => {
        //     // this.avatar = res.data.data.user.profile
        //   }).catch(err => {
        //     console.log('err getprofile', err)
        //   })
        // },
        setgetProfile({ commit }, payload) {
          commit("SET_DIALOG_PROFILE", payload);
        },
        setdatadialogparticipants_pexipend({ commit }, payload) {
          commit("SET_DIALOG_PARTICIPANTSEND", payload);
        },
        setDialogcoppylink({ commit }, payload) {
          commit("SET_DIALOG_COPPYLINK", payload);
        },
        setDialogdatacoppylink({ commit }, payload) {
          commit("SET_DATA_COPPYLINK", payload);
        },
        setdatadialogreporthistory({ commit }, payload) {
          commit("SET_DATA_REPORTHISTORY", payload);
        },
        setdialogreporthistory({ commit }, payload) {
          commit("SET_DIALOG_REPORTHISTORY", payload);
        },
        setSwitchSignSignup({ commit }, payload) {
          commit("SET_DIALOG_SWITCH", payload);
        },
        setdatahistory({ commit }, payload) {
          commit("SET_DATA_HISTORY", payload);
        },
        setMeetingIdReport({ commit }, payload) {
          commit("SET_DIALOG_REPORTMEET", payload);
        },
        setIdReportvote({ commit }, payload) {
          commit("SET_DIALOG_REPORTVOTE", payload);
        },
        setDialogScheduleEdit({ commit }, payload) {
          commit("SET_DIALOG_EDITSCHEDULE", payload);
          commit("SET_DIALOG_EDITROOM", false);
        },
        setDialogeditroom({ commit }, payload) {
          commit("SET_DIALOG_EDITROOM", payload);
        },
        setDialogdataedit({ commit }, payload) {
          commit("SET_DIALOG_DATAEDIT", payload);
        },
        setDialogRoomSetting({ commit }, payload) {
          commit("SET_DIALOG_ROOMSETTING", payload);
        },
        setDialogScheduleSetting({ commit }, payload) {
          commit("SET_DIALOG_SCHEDULESETTING", payload);
        },
        setDialogDevice({ commit }, payload) {
          commit("SET_DIALOG_DEVICE", payload);
        },
        setDialogLogin({ commit }, payload) {
          commit("SET_DIALOG_LOGIN", payload);
        },
        setUuidVideo({ commit }, payload) {
          commit("SET_DIALOG_UUID_VIDEO", payload);
        },
        setUuidAudio({ commit }, payload) {
          commit("SET_DIALOG_UUID_AUDIO", payload);
        },
        setdialogvideo({ commit }, payload) {
          commit("SET_DIALOG_VIDEO", payload);
        },
        sethistoryload({ commit }, payload) {
          commit("SET_DIALOG_HISTORYLOAD", payload);
        },
        setDataRoomSchedule({ commit }, payload) {
          commit("SET_DATA_ROOM_SCHEDULE", payload);
        },
      },
      namespaced: true,
    },
  },
});
